import { isIosUserAgent, useUserAgent } from './useUserAgent';

export const useIsIOS = () => isIosUserAgent(useUserAgent());
